import { persist } from 'easy-peasy';
import AppModel from './types/AppModel';
import analyticsModel from '../analytics/analyticsModel';
import navigationModel from '../navigation/navigationModel';
import orgContextModel from '../orgContext/orgContextModel';
import productModel from '../products/productModel';

const appModel: AppModel = {
  analytics: analyticsModel,
  products: productModel,
  navigation: persist(navigationModel, {
    storage: 'localStorage',
    allow: ['navigation'],
  }),
  orgContext: orgContextModel,
};

export default appModel;
